// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U1: КАРТА ОБЪЯСНЕНИЙ ОБЛАСТИ «ГРИД» (handoff-files/ui-help-2026-09-24/spec-grid.json).
// Здесь — ссылочная ячейка: у неё УЖЕ есть своя подсказка (AttrGrid.cellTooltip_html: Title / ID / Relation segment + кнопки Open / Copy / New tab), поэтому
// объяснение ДОПИСЫВАЕТСЯ строками (способ 2 ядра), кнопки остаются; туда же — объяснение самой записи от поставщиков записей (точка расширения, R2).
// Остальные ключи области (метки ячеек «Marks», форма ячейки, заголовки строк и колонок — 116 элементов спецификации) — волна U5 дописывает в этот же файл.
import { t } from '@/i18n'

const grid = {
    // ссылочная ячейка (колонка с relation_segment: AttrLink / AttrMulti / AttrLinkChips; строка-поле формы AttrTabGrid со ссылкой); сегмент записи уже стоит в подсказке
    // строкой Relation segment. Клик: Alt + клик по ячейке открывает запись (AttrGrid, обработчик Alt + Click по значению → onButtonOpen__Click), кнопки подсказки — tipCell_action
    'grid.cellLink': () => ({
        title: t('Link to a record'),
        what: t('The value is a link to a record: the cell keeps its ID and shows its title.'),
        click: t('The buttons below open the record, copy a link to it or open it in a new browser tab; Alt + click on the cell opens it too. This table does not change.'),
    }),

    // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение): выпадашка поля ячейки шахматки (AttrCrossGrid v2, cell_value_options)
    'grid.crossValue': () => ({
        title: t('What the matrix cells show'),
        what: t('Which field of the table {table} the matrix cells show and edit; the list holds the columns of that table.'),
        affects: t('A view setting: it is kept with the form view and does not change the data.'),
    }),
    // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106094: шахматка — вид слайда, центрирование, группы без фона) (p051): кнопка «Slide look» быстрой панели ⚙ шахматки (viewParams.<шахматка>.slide_look)
    'grid.viewParams.slideLook': () => ({
        title: t('Slide look'),
        what: t('Shows the matrix like a slide: values as rounded blocks with the text of the cell row, headers and row labels without background, row labels in the row colour.'),
        click: t('Click to switch.'),
        affects: t('Off - a plain grid: the values as they are (checkboxes, text) and the standard headers. A view setting: the data does not change.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.slide_look',
    }),

    // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — форма ячейки со строками и правкой): блок строк ячейки шахматки в форме ячейки (Dropdown: вкладки Row / Node / Column, «Open line»)
    'grid.crossCards': () => ({
        title: t('Rows behind the matrix cell'),
        what: t('Row — the row of the cell table for this pair (node × field, horizon or target node), Node — the row of the matrix, Column — its column; the fields show the current values from the grids of the form.'),
        click: t('Click a tab — show its row; a grey tab has no row for this cell: the click says why. Open line or a field — the row form for editing (an open row form follows the tab).'),   // IE 2026 10 25 / ODOO-348878 (заказ Игоря: шахматка — выбор поля, подсветка use, взаимное выделение) (p040): + серая вкладка — клик поясняет
        affects: t('Edits in the row form go to the table of the record: Save keeps them with the record, closing without saving drops them; the matrix and the grids redraw.'),
    }),
    'grid.crossCards.open': () => ({
        title: t('Open line'),
        what: t('Opens the form of this row with its fields for editing; Save keeps the edits with the record.'),
    }),

    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: цвета как на слайде — редактор цвета ColorPicker): палитра ячейки колонки editor 'color' (AttrGrid colorEd_*)
    'grid.colorEditor': () => ({
        title: t('Colour picker'),
        what: t('Pick the colour in the square and on the hue bar, or type a hex code #RRGGBB in the cell.'),
        click: t('Enter or Apply saves the colour to the row (undo and Save as for any cell), Esc cancels; No colour clears it.'),
    }),

    // === U5 additions start (handoff-files/ui-help-2026-09-24/waves/U5/) ===
    // ---- commandPanel/cmd (панель команд грида) (19) ----
    'grid.commandPanel.backend': (v = {}, ctx = {}) => ({
        title: t('Table command'),
        what: t('A command the server configured for this table (for example Save or Update data).'),
        why: t('Actions specific to this kind of widget; the same commands are listed in the ≡ Table menu.'),
        click: t('Click — run the command; the hotkey shown in the tooltip runs it from the keyboard.'),
        affects: t('Depends on the command: reading data replaces the rows, saving writes the record; a greyed Save means nothing to save yet.'),
        setting: 'attr.groupMenu.commandPanel (server)',
    }),
    'grid.commandPanel.overflow': (v = {}, ctx = {}) => ({
        title: t('More commands'),
        what: t('Commands of the panel that did not fit into the width of the table.'),
        why: t('The panel shrinks with the widget; the hidden commands stay reachable here.'),
        click: t('Hover or click — the list of hidden commands; click an item to run it.'),
        affects: t('The same as the command itself.'),
    }),
    // IE 2026 11 01 / ODOO-350449 (заказ Игоря: форма Стовпчики та Запас площею — T15): переключатель формы вида ячеек в строке команд грида
    'grid.cellShape': (v = {}, ctx = {}) => ({
        title: t('Cell shape'),
        what: t('How the active cell view is drawn: circles, bars (one bar per layer) or a filled area under the stock curve (stock rows only).'),
        why: t('Bars compare the layers side by side; the area shows how stock rises and falls from period to period.'),
        click: t('Click a shape — every row uses it; click the selected shape again — back to the shape set in the view option.'),
        affects: t('Only this widget; nothing is recalculated.'),
        stored: t('Nothing is stored.'),
        setting: 'fe.ux.cellViewBars; fe.ux.cellViewArea; Options → Shape (server)',
    }),
    // IE 2026 11 02 / ODOO-350449 (замечание Игоря по dev02, p183: перемикач «Рядки: Компактні / Високі» у таблиці REPORT2, як у Heatmap (grid)): переключатель высоты строк в строке команд грида
    'grid.gridRows': (v = {}, ctx = {}) => ({
        title: t('Row height'),
        what: t('Compact rows keep the usual height of the table; tall rows are 34 px with the text centred vertically, as on the Heatmap tab.'),
        why: t('Circles, bars and areas of the cell views are drawn larger in tall rows.'),
        click: t('Click the button: pressed — tall rows, released — compact rows. A cell view with circles turns tall rows on once, until you choose the height yourself; Numbers keep the height.'),   // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p189 — «Рядки» одной квадратной кнопкой: нажата = високі, отжата = компактні)
        affects: t('Only this widget; nothing is recalculated.'),
        stored: t('Nothing is stored.'),
        setting: 'fe.ux.gridRowsSwitch',
    }),
    'grid.cmd.add': (v = {}, ctx = {}) => ({
        title: t('Add row'),
        what: t('Adds an empty row at the selected position.'),
        why: t('To enter a new element or line of this table.'),
        click: t('Click or Alt + — fill in the new row, then save the widget.'),
        affects: t('Turns off «Hide empty rows, columns, tabs» so the empty row stays visible; Ctrl+Z undoes.'),
        stored: t('In the record — after Save'),
        setting: 'attr.allowAddNew',
        hotkey: 'Alt +',
    }),
    'grid.cmd.copy': (v = {}, ctx = {}) => ({
        title: t('Copy'),
        what: t('Copy the selected rows (JSON), the cell, the filters behind the cell or its values; Clone duplicates rows here.'),
        why: t('To move rows between tables or reuse the filters that produce a number.'),
        click: t('Hover — the list; pick what to copy. Insert copied rows (Alt V) pastes them.'),
        affects: t('Copies go to the clipboard; Clone changes the table (Ctrl+Z undoes).'),
        hotkey: 'Alt C · Shift Alt C · Ctrl Alt C · Shift Ctrl Alt C · Shift Alt ↓',
    }),
    'grid.cmd.insert': (v = {}, ctx = {}) => ({
        title: t('Insert copied rows'),
        what: t('Inserts rows from the clipboard after the selected row.'),
        why: t('Moves rows copied with Copy rows (Alt C) between tables and widgets.'),
        click: t('Select a row, click or press Alt V.'),
        affects: t('The table changes; saved with Save; Ctrl+Z undoes. An empty or non-JSON clipboard gives a warning.'),
        stored: t('In the record — after Save'),
        hotkey: 'Alt V',
    }),
    'grid.cmd.delete': (v = {}, ctx = {}) => ({
        title: t('Delete rows'),
        what: t('Removes the selected rows from the table.'),
        why: t('To drop lines or records you do not need.'),
        click: t('Select rows, click (Alt −). There is no confirmation — Ctrl+Z brings them back.'),
        affects: t('Stored records are deleted only when the widget is saved; hidden (filtered) rows are not touched.'),
        stored: t('In the record — after Save'),
        setting: 'attr.isRecords · attr.visibleBtnArchived',
        hotkey: 'Alt -',
        states: { 'rows': t('Delete rows (−): lines of this table.'), 'records': t('Delete records (trash): the records are marked for deletion and removed on Save.'), 'archive': t('Archive/Restore (box): toggles the archive flag; archived records stay in the base.') },
    }),
    'grid.cmd.move': (v = {}, ctx = {}) => ({
        title: t('Move rows'),
        what: t('Moves the selected rows up or down; in a tree — one level left (out) or right (in).'),
        why: t('Order and nesting matter: layouts, menus, rules are read top-down.'),
        click: t('Click or Alt+arrow; rows can also be dragged with Alt held.'),
        affects: t('Changes order or parent in the record; Ctrl+Z undoes.'),
        stored: t('In the record — after Save'),
        setting: 'fe.ux.rowDrag',
        hotkey: 'Alt ↑ · Alt ↓ · Alt ← · Alt →',
        states: { 'up': t('Move up (Alt ↑).'), 'down': t('Move down (Alt ↓).'), 'left': t('One level out — the row leaves its parent (Alt ←).'), 'right': t('One level in — the row goes under the row above (Alt →).') },
    }),
    'grid.cmd.undo': (v = {}, ctx = {}) => ({
        title: t('Undo'),
        what: t('Reverts the last change made in this table.'),
        why: t('A mistyped value, a wrong paste, a deleted row — step back.'),
        click: t('Click or Ctrl+Z; the ▾ next to it lists the last actions.'),
        affects: t('Works on the changes of this session in this table.'),
        stored: t('Session (in memory)'),
        hotkey: 'Ctrl+Z · Cmd+Z',
    }),
    'grid.cmd.redo': (v = {}, ctx = {}) => ({
        title: t('Redo'),
        what: t('Repeats a change you have just undone.'),
        why: t('Undid one step too many — bring it back.'),
        click: t('Click or Ctrl+Y; the ▾ next to it lists the undone actions.'),
        affects: t('Only actions undone in this session.'),
        stored: t('Session (in memory)'),
        hotkey: 'Ctrl+Y · Cmd+Shift+Z',
    }),
    'grid.cmd.history': (v = {}, ctx = {}) => ({
        title: t('Action history'),
        what: t('The list of the last actions (or undone ones) of this table.'),
        why: t('To go back several steps at once.'),
        click: t('Open ▾, hover an action — the steps up to it are highlighted; click to revert (or repeat) them all.'),
        affects: t('Same as Undo / Redo, several steps at once.'),
        stored: t('Session (in memory)'),
        states: { 'undo': t('Undo history — last actions.'), 'redo': t('Redo history — undone actions.') },
    }),
    'grid.cmd.clearCells': (v = {}, ctx = {}) => ({
        title: t('Clear manual corrections'),
        what: t('Removes the values typed in by hand in the selected cells; the calculated values come back.'),
        why: t('To return a cell to the calculation after a manual override.'),
        click: t('Select cells, click the eraser.'),
        affects: t('Dependent cells are recalculated; applied when the report is saved; Ctrl+Z undoes.'),
        stored: t('In the record (_cells) — after Save'),
        setting: 'attr.use_cells (Settings → Corrections)',
    }),
    'grid.cmd.lightView': (v = {}, ctx = {}) => ({
        title: t('Light / full view'),
        what: t('Switches between the Title column only (tree) and all columns.'),
        why: t('Long field lists are easier to scan in the light view.'),
        click: t('Click to switch; pressed — full view.'),
        affects: t('Only how the table looks.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.lightView',
        states: { 'light': t('Light: Title only.'), 'full': t('Full: all columns.') },
    }),
    'grid.cmd.metricChipSet': (v = {}, ctx = {}) => ({
        title: t('Set metrics chip'),
        what: t('Makes the metrics of the selected rows the workspace metrics chip.'),
        why: t('From a metrics report, show the same problems in all widgets of the workspace.'),
        click: t('Select rows with a grade / metric / reason, click; Shift or Ctrl + click adds them to the current chip.'),
        affects: t('Widgets that accept the chip filter their rows or re-read the data.'),
        stored: t('Workspace chips'),
        setting: 'fe.ux.metricChipGlobal',
        hotkey: 'Shift / Ctrl + click — add',
    }),
    'grid.cmd.style': (v = {}, ctx = {}) => ({
        title: t('Merge and style'),
        what: t('Merges the selected cells; Style sets colours and fonts of cells or rows.'),
        why: t('Formatting of print templates and field tables.'),
        click: t('Select cells, pick the command or a style property.'),
        affects: t('The look of the cells is saved in the record.'),
        stored: t('In the record — after Save'),
        setting: 'attr.use_commandPanelCell · attr.rowStyleButtons',
    }),
    'grid.cmd.fieldsMapping': (v = {}, ctx = {}) => ({
        title: t('Update / Test mapping'),
        what: t('Update evaluates the mapping rows as on widget open; Test does the same for a date you enter.'),
        why: t('To check what values the widget will receive without reopening it.'),
        click: t('Click Update; for Test enter the date in the dialog.'),
        affects: t('The parameters of the widget get the evaluated values.'),
        states: { 'update': t('Update — now.'), 'test': t('Test — at the date you enter.') },
    }),
    'grid.cmd.aggAll': (v = {}, ctx = {}) => ({
        title: t('All sources'),
        what: t('Adds the rows of the other sources to the summary table (the badge — how many).'),
        why: t('To see all rules in one table, not only the main source.'),
        click: t('Click to switch; pressed — all sources.'),
        affects: t('Only which rows are shown.'),
    }),
    'grid.cmd.sourceFields': (v = {}, ctx = {}) => ({
        title: t('Source fields'),
        what: t('Opens the list of fields of the source to pick which of them go into this table.'),
        why: t('Faster than adding rows one by one.'),
        click: t('Click, tick the fields in the list.'),
        affects: t('Rows of this table are added or switched off by the ticks.'),
        stored: t('In the record — after Save'),
        setting: 'attr.use_itemsSourcesView',
    }),
    'grid.cmd.readOnlyOff': (v = {}, ctx = {}) => ({
        title: t('Allow editing'),
        what: t('Switches off the read-only mode of this table.'),
        why: t('Some tables are protected by default; edit them only on purpose.'),
        click: t('Click — the table becomes editable.'),
        affects: t('You can change and save the values of this table.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.isReadOnly',
    }),
    // IE 2026 10 14 / ODOO-5800 (Igor: правка динамических списков как у виджета списка): Save / Cancel / Open record панели грида ленивой вкладки с saveMethod
    'grid.cmd.editSave': (v = {}, ctx = {}) => ({
        title: t('Save the changed rows'),
        what: t('Writes the changed, added and deleted rows of this list; the badge shows how many rows changed.'),
        why: t('The rows of this list are saved by their own method, not with the record.'),
        click: t('Click — the rows are sent; the list shows the saved rows.'),
        affects: t('Only this list. The record of the widget is not saved.'),
        stored: t('In the database — at once'),
    }),
    'grid.cmd.editCancel': (v = {}, ctx = {}) => ({
        title: t('Cancel the editing'),
        what: t('Discards the unsaved changes of this list and returns it to read-only.'),
        why: t('A way out without saving.'),
        click: t('Click — the loaded rows are restored, the editing buttons disappear.'),
        affects: t('Only this list.'),
    }),
    'grid.cmd.openRecord': (v = {}, ctx = {}) => ({
        title: t('Open the record of the row'),
        what: t('Opens the record behind the current row in a widget (the same as the arrow in the row header).'),
        why: t('The row of this list is a record of its own: open it to see or edit all its fields.'),
        click: t('Click — the record opens. Inactive when the current row has no record id.'),
        affects: t('Opens a widget; nothing changes in this table.'),
    }),
    'grid.cmd.groupAll': (v = {}, ctx = {}) => ({
        title: t('Group all / Ungroup all'),
        what: t('Collapses or expands all row groups of the table.'),
        why: t('Quick overview of a long grouped table.'),
        click: t('Click Group all to collapse, Ungroup all to expand.'),
        affects: t('Only what is visible.'),
    }),
    // ---- chips / tags / summary (полоса над таблицей) (3) ----
    'grid.chips': (v = {}, ctx = {}) => ({
        title: t('Chips of the table'),
        what: t('Search and filters of this table: text, column filters, metrics, formatting and style chips.'),
        why: t('Narrow the table to what you need.'),
        click: t('Type in the field and press Enter; each filter becomes a chip; ⊗ switches a chip off.'),
        affects: t('Only the rows shown here (unless a chip acts on the server — Input).'),
        stored: t('With the widget (viewParams.<grid>.CHIPS)'),
        setting: 'viewParams.<grid>.hideCHIPS',
    }),
    'grid.tagsPanel.tag': (v = {}, ctx = {}) => ({
        title: t('Tag'),
        what: t('A tag used in this segment; the list can be filtered by it.'),
        why: t('Quick filter by labels without typing.'),
        click: t('Click — add or remove the tag chip; a highlighted tag is active (several tags narrow the list).'),
        affects: t('The list is re-read from the server with the tag filter.'),
        stored: t('With the widget (chips of the table)'),
        setting: 'attr.tags_panel',
        states: { 'active': t('Active — the list is filtered by this tag.') },
    }),
    'grid.summaryLine': (v = {}, ctx = {}) => ({
        title: t('Selection sum'),
        what: t('Σ of the numbers in the selected cells; the tooltip gives count, average, minimum and maximum.'),
        why: t('A quick total without a calculator.'),
        click: t('Select two or more cells with numbers; durations are summed as time.'),
        affects: t('Nothing — display only.'),
        stored: t('The line is switched on in View params (Grid summary line)'),
        setting: 'viewParams.<grid>.showGridSummaryLine',
    }),
    // ---- viewParams (⚙ параметры вида) (8) ----
    'grid.viewParams.cog': (v = {}, ctx = {}) => ({
        title: t('View params'),
        what: t('How this table looks: columns, frozen area, sorting, filters, empty rows.'),
        why: t('Adjust the table to your task without changing the data.'),
        click: t('Hover — quick switches (while Alt is held, hovering shows this explanation instead); click (Alt F1) — the form of columns, opened on the selected column.'),
        affects: t('Only the view of this table.'),
        stored: t('With the widget (doc.viewParams.<grid>) — Save as my / for all'),
        hotkey: 'Alt F1',
    }),
    'grid.viewParams.hideCHIPS': (v = {}, ctx = {}) => ({
        title: t('Hide filter chips'),
        what: t('Hides the chips bar above this table.'),
        why: t('More room for data when you do not filter.'),
        click: t('Click to switch.'),
        affects: t('Chips that are already on keep filtering — they are just not shown.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.hideCHIPS',
    }),
    'grid.viewParams.showFilter': (v = {}, ctx = {}) => ({
        title: t('Column filters'),
        what: t('Shows or hides the filter icons in the column headers.'),
        why: t('Column filters let you pick values or conditions per column.'),
        click: t('Click to switch.'),
        affects: t('Hiding the icons does not remove filters already set on columns.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.showFilter',
    }),
    'grid.viewParams.showEmpty': (v = {}, ctx = {}) => ({
        title: t('Show empty'),
        what: t('Keeps empty rows and columns of this table visible even when «Hide empty rows, columns, tabs» is on.'),
        why: t('When you need to see or fill empty lines.'),
        click: t('Click to switch.'),
        affects: t('Only this table; other tables of the widget follow the widget filter.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.showEmpty',
    }),
    'grid.viewParams.hideEmptyRows': (v = {}, ctx = {}) => ({
        title: t('Grey empty rows'),
        what: t('Shows the rows of this table that have no values in grey.'),
        why: t('Separate data lines from empty frame lines at a glance.'),
        click: t('Click to switch. To hide empty rows use the widget button «Hide empty rows, columns, tabs».'),
        affects: t('Only the look; no row is hidden by this switch.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.hideEmptyRows',
    }),
    'grid.viewParams.sorting': (v = {}, ctx = {}) => ({
        title: t('Sorting'),
        what: t('Whether a click on a column header sorts the table, by one or by several columns.'),
        why: t('Find the biggest or the latest quickly.'),
        click: t('Pick Single column or Multi column; then click headers (with Multi — each click adds a column).'),
        affects: t('Only the order of rows on screen.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.allowSorting · fe.grid.allowSorting',
        states: { 'single': t('Single column.'), 'multi': t('Multi column.') },
    }),
    'grid.viewParams.frozen': (v = {}, ctx = {}) => ({
        title: t('Frozen columns and rows'),
        what: t('How many left columns and top rows stay in place while you scroll.'),
        why: t('Names of rows stay visible next to far-right numbers.'),
        click: t('Enter the number.'),
        affects: t('Only the view.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.frozenColumns · frozenRows',
    }),
    'grid.viewParams.more': (v = {}, ctx = {}) => ({
        title: t('View params'),
        what: t('Further switches of how this table looks.'),
        why: t('Fine tuning for reading, printing or diagnostics.'),
        click: t('Click a switch or enter a number; the pressed state is the current one.'),
        affects: t('Only the view of this table.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.*',
        states: { 'headersVisibility': t('Headers: All / Column / Row — which headers the table shows.'), 'allowPinning': t('Pinning — pin a column to the left with the pin in its header.'), 'rowsHeight': t('Rows height 1–7 — denser or looser rows.'), 'collapseGroupsToLevel': t('Collapse rows to level — the tree opens collapsed to this level.'), 'aggregateFooters': t('Aggregate footers — a totals row at the bottom.'), 'use_delivery': t('Breaks — gaps before columns marked «Break before» and between sections of the tree.'), 'tree_lines_dotted': t('Dotted tree lines — old dotted lines with section gaps; off — frame lines.'), 'service': t('Performance, Cell factory, Format, Cache rows / cols — diagnostics for developers.') },
    }),
    // ---- заголовки строк / углы (rowHeaders, topLeft, fold badges) (9) ----
    'grid.foldBadge': (v = {}, ctx = {}) => ({
        title: t('Level badges'),
        what: t('Numbers 1…N collapse the tree of rows (vertical strip) or the groups of columns (horizontal strip) to that level; the last one expands everything.'),
        why: t('One click instead of collapsing groups one by one.'),
        click: t('Hover the top-left corner of the table (or click it) — the badges appear; click a number.'),
        affects: t('Only what is shown; data and totals do not change.'),
        stored: t('Not stored — the table view only'),
        setting: 'fe.ux.groupBadgesDelayMs',
        states: { 'rows': t('Rows: collapse the tree to this level.'), 'cols': t('Columns: collapse the groups of columns (years, quarters…) to this level.'), 'expandAll': t('The last number expands everything.') },
    }),
    'grid.rowHeader.open': (v = {}, ctx = {}) => ({
        title: t('Open the row'),
        what: t('Opens the element of this row (→) or runs the row command shown by the icon (for example choose this setting).'),
        why: t('The quickest way to the record behind a line.'),
        click: t('Click the icon in the row header — the same as a double click on the row.'),
        affects: t('Opens a widget of the element; nothing changes in this table.'),
        hotkey: 'Double click on the row does the same',
        states: { 'open': t('→ — open the element of the row.'), 'command': t('Another icon — the row command of this list (for example ✓ choose).') },
    }),
    'grid.rowHeader.selector': (v = {}, ctx = {}) => ({
        title: t('Selector'),
        what: t('Marks the row as a selected value of this list; the selected values filter other widgets of the workspace.'),
        why: t('Choose objects, subjects, periods… for the whole page from a list.'),
        click: t('Click — tick or untick (all selected rows at once); Alt / Ctrl + click — only this row.'),
        affects: t('Widgets that read this selector re-read or filter their data. A tick is a selection, not data: the row and the record are not marked as changed (in the Conditional format grid the tick is a setting of the rule and is saved with the widget).'),
        stored: t('Workspace chips'),
        hotkey: 'Ctrl+/ — this row only · Ctrl+Enter — toggle',
        states: { 'workspace': t('Selector list: the ticked rows become the workspace chip.'), 'metricsTab': t('Metrics tab: the ticked metrics make up the metrics chip of the table.'), 'formatRules': t('Conditional format: the ticked rules go into the formatting chip above the table.') },
    }),
    'grid.rowHeader.use': (v = {}, ctx = {}) => ({
        title: t('Use'),
        what: t('Switches the row on or off: an unticked row stays in the list but does not take part in the result.'),
        why: t('Try a setting without deleting the row.'),
        click: t('Click — switch (all selected rows at once); Alt / Ctrl + click — only this row.'),
        affects: t('The record becomes modified; an unticked row and its children count as empty and are struck through.'),
        stored: t('In the record — after Save'),
        states: { 'metricsTab': t('Metrics tab: whether the formatting of this metric is shown in the table.') },
    }),
    'grid.rowHeader.selectAll': (v = {}, ctx = {}) => ({
        title: t('Tick all / untick all'),
        what: t('Ticks every visible row of this column, or clears the ticks if some visible rows are ticked.'),
        why: t('Mass switch instead of row by row.'),
        click: t('Click: if any visible row is ticked — the ticks are cleared, otherwise every visible row is ticked. Hover (without Alt) — the item Filter checked rows.'),
        affects: t('The same as ticking each visible row; rows hidden by a search chip keep their ticks (selector — the workspace chip; use — the record becomes modified).'),
        states: { 'all': t('Dark teal — all rows are ticked.'), 'some': t('Orange — some rows are ticked.'), 'none': t('Plain — nothing is ticked.') },
    }),
    'grid.rowHeader.selectAllMenu': (v = {}, ctx = {}) => ({
        title: t('Filter checked rows'),
        what: t('Shows only the ticked rows of this column (adds a search chip).'),
        why: t('Review what is ticked in a long list.'),
        click: t('Click the item; remove the chip to see all rows again.'),
        affects: t('Only which rows are visible.'),
        stored: t('With the widget (chips of the table)'),
    }),
    'grid.rowHeader.feSelected': (v = {}, ctx = {}) => ({
        title: t('Marked rows'),
        what: t('Tick boxes that add or remove a row from the selection of the table.'),
        why: t('Select scattered rows for copy, delete or a command.'),
        click: t('Tick rows one by one; the header tick selects or clears all.'),
        affects: t('Only the selection.'),
        stored: t('Not stored'),
    }),
    'grid.rowHeader.groupColResize': (v = {}, ctx = {}) => ({
        title: t('Width of the group column'),
        what: t('Drag the right edge of the group column in the row headers to change its width.'),
        why: t('Wide group names or a compact table.'),
        click: t('Hover the right edge until the cursor changes, then drag.'),
        affects: t('Only the view; ≡ → Restore default sizes returns the automatic width.'),
        stored: t('With the widget (view params)'),
        setting: 'viewParams.<grid>.attr_by_binding.<binding>.width',
    }),
    'grid.collapseToggle': (v = {}, ctx = {}) => ({
        title: t('Collapse / expand'),
        what: t('Hides or shows the rows inside this group.'),
        why: t('Read the totals first, open the details when needed.'),
        click: t('Click the triangle; level badges in the top-left corner collapse the whole tree to a level.'),
        affects: t('Only what is shown.'),
        stored: t('Not stored'),
    }),
    // ---- ячейка: стрелка формы, ссылка, фильтр колонки, непустые (4) ----
    'grid.cellFormArrow': (v = {}, ctx = {}) => ({
        title: t('Cell form'),
        what: t('Opens the form of this cell: commands, history of edits, metrics, rules, formatting, documents and details.'),
        why: t('Everything known about one number, without editing it.'),
        click: t('Click the arrow or press F4 on the selected cell. Close the form with ✕, F4 or Esc; after that neither the keys nor a click on a cell opens it — only the Cell form button or F4 do, and then the form follows the selected cell again.'),   // IE 2026 10 10 / ODOO-5800
        affects: t('Nothing changes until you use a command of the form.'),
        setting: 'fe.ux.cellFormArrow · fe.ux.cellFormHotkey · fe.ux.cellFormCloseAlways · fe.ux.cellFormSessionMemory · fe.ux.cellFormReopenByButton',   // IE 2026 10 10 / ODOO-5800
        hotkey: 'F4',
        states: { 'closed': t('▾ — the form of this cell is closed.'), 'open': t('▴ — the form is open for this cell; a click closes it.') },
    }),
    // IE 2026 09 29 / ODOO-343342 (заказ Игоря: форма ячейки по 🏷): кнопка 🏷 в строке команд вместо шеврона в ячейке
    'grid.cellFormTagBtn': (v = {}, ctx = {}) => ({
        title: t('Cell form'),
        what: t('Opens the form of this cell: commands, history of edits, metrics, rules, formatting, documents and details.'),
        why: t('Everything known about one number, without editing it.'),
        click: t('Click the button (or press F4) to open the form of the selected cell. Close it with the button, ✕, F4 or Esc; after that neither the keys nor a click on a cell opens it — only this button or F4 do, and then the form follows the selected cell again.')
            + ' ' + t('A right-click on a cell opens its form too.'),   // IE 2026 10 10 / ODOO-5800; IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
        affects: t('Nothing changes until you use a command of the form.'),
        setting: 'fe.ux.cellFormTagBtn · fe.ux.cellFormHotkey · fe.ux.cellFormCloseAlways · fe.ux.cellFormSessionMemory · fe.ux.cellFormReopenByButton · fe.ux.contextMenuActions · fe.ux.cellFormKeepOnResize',   // IE 2026 10 10 / ODOO-5800; IE 2026 10 12 / ODOO-343342 (заказ Игоря: правая кнопка мыши — форма ячейки / строки / меню виджета)
        hotkey: 'F4',
        states: { 'closed': t('The form of the selected cell is closed.'), 'open': t('The form is open; a click closes it.') },
    }),
    'grid.cellLinkIcon': (v = {}, ctx = {}) => ({
        title: t('Open the linked record'),
        what: t('The icon of the segment before a value: this cell refers to a record of that segment.'),
        why: t('Jump to the element behind the value.'),
        click: t('Click the icon (or Alt + click anywhere in the cell).'),
        affects: t('Opens a widget with the record; this table does not change.'),
        setting: 'fe.ux.tooltipActions',
        hotkey: 'Alt + click on the cell — open',
    }),
    'grid.columnFilter': (v = {}, ctx = {}) => ({
        title: t('Column filter'),
        what: t('Filter this column by values or by a condition.'),
        why: t('Narrow a long table by one column.'),
        click: t('Click the funnel in the header, pick values or a condition, Apply. Orange funnel — the column is filtered.'),
        affects: t('Only the rows shown; the filter appears as a chip of the table; in a tree the parents of matching rows stay.'),
        stored: t('With the widget (chips of the table)'),
        setting: 'viewParams.<grid>.showFilter',
        states: { 'active': t('Orange funnel — a filter is set on this column.') },
    }),
    'grid.nonEmptyFilter': (v = {}, ctx = {}) => ({
        title: t('Hide empty rows, columns, tabs'),
        what: t('Hides rows, columns and tabs without values in all tables of the widget; the badge shows how many are hidden.'),
        why: t('Only lines with data are left — long reports become readable.'),
        click: t('Click or Alt A to switch; off — everything is shown.'),
        affects: t('Only what is shown; a table with «Show empty» keeps its empty lines; adding a row switches it off.'),
        stored: t('The widget (on by default)'),
        setting: 'non-empty-widget (server)',
        hotkey: 'Alt A',
        states: { 'on': t('On — empty lines are hidden.'), 'off': t('Off — everything is shown.') },
    }),
    // ---- форма ячейки — F4 (Dropdown.vue): общее (6) ----
    'grid.cellForm': (v = {}, ctx = {}) => ({
        title: t('Cell form'),
        what: t('Everything about the selected cell: commands, formula of the stock, edit history, metrics, rules, formatting, documents, details.'),
        why: t('Explains where a number comes from and what to do with it.'),
        click: t('Blocks collapse by their headers; the pin detaches the form into the corner of the widget; ✕, F4 or Esc close it — after that neither the keys nor a click on a cell reopens it, only the 🏷 Cell form button or F4 do, and then the form follows the selected cell again.'),   // IE 2026 10 10 / ODOO-5800
        affects: t('Commands of the form act on this cell or row; reading blocks change nothing.'),
        stored: t('Collapsed blocks — in this browser; attached / detached — with the table'),
        setting: 'viewParams.<grid>.cellForm_onClick · cellForm_detached · fe.ux.cellFormOnClick · fe.ux.cellFormDetached · fe.ux.cellFormReopenByButton',   // IE 2026 10 10 / ODOO-5800
        hotkey: 'F4 · Esc',
    }),
    'grid.cellForm.pin': (v = {}, ctx = {}) => ({
        title: t('Pin the form'),
        what: t('Detaches the form into the corner of the widget, where it follows the selected cell; click again to attach it to the cell.'),
        why: t('Walk through cells with the arrow keys and read their forms without reopening.'),
        click: t('Click the pin; drag the detached form by its top edge, resize by the edges.'),
        affects: t('Only the position of the form.'),
        stored: t('The mode by default is set per table'),
        setting: 'viewParams.<grid>.cellForm_detached · fe.ux.cellFormDetached',
        states: { 'attached': t('Attached to the cell.'), 'detached': t('Detached, in the corner of the widget.') },
    }),
    'grid.cellForm.anchor': (v = {}, ctx = {}) => ({
        title: t('Cell of the form'),
        what: t('Which cell the detached form describes: row dimensions · column · value.'),
        why: t('The form may stay open while the cell scrolls away.'),
        click: t('Click — scroll to the cell and select it.'),
        affects: t('Nothing.'),
    }),
    'grid.cellForm.search': (v = {}, ctx = {}) => ({
        title: t('Search in the form'),
        what: t('Filters the lines of the form blocks by the text you type.'),
        why: t('A cell with many documents or rules — find the one you need.'),
        click: t('Type; «n of m» counts matching lines; Esc clears (an empty field — Esc closes the form).'),
        affects: t('Only what the form shows; the chart and DOS are not filtered.'),
        setting: 'fe.cellForm.search',
        hotkey: 'Esc — clear',
    }),
    'grid.cellForm.row': (v = {}, ctx = {}) => ({
        title: t('Row commands'),
        what: t('Commands for the whole row of this cell: open the line in a form, run the row command, show the children of the row.'),
        why: t('Row-level actions next to the number you are looking at.'),
        click: t('Click a button; Alt F2 opens the line form from the keyboard.'),
        affects: t('Open line opens a form of the row; other commands — see their tooltip.'),
        hotkey: 'Alt F2 — Open line',
    }),
    'grid.cellForm.blockToggle': (v = {}, ctx = {}) => ({
        title: t('Collapse / expand the block'),
        what: t('A collapsed block shows a one-line summary; expanded — all lines.'),
        why: t('Keep the form short and open only what you need.'),
        click: t('Click the block header.'),
        affects: t('Nothing; the choice is remembered for all cells.'),
        stored: t('In this browser'),
    }),
    // ---- форма ячейки — блок CELL (команды AttrGrid.vue) (12) ----
    'grid.cellForm.cell.open': (v = {}, ctx = {}) => ({
        title: t('Open'),
        what: t('Opens the record the cell refers to.'),
        why: t('See or edit the linked element.'),
        click: t('Click.'),
        affects: t('Opens a widget; this table does not change.'),
        hotkey: 'Alt + click on the cell',
    }),
    // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115712, слово Igor: relation_row — переход к шагу согласования): «→» колонки с relation_row (AttrGrid.relationRow_cellTarget; vars — utils/relationRow.relationRow_helpVars)
    'grid.cellForm.cell.openRelationRow': (v = {}, ctx = {}) => ({
        title: t('Open the linked row'),
        what: t('Opens the record {id} of {segment} on {path} and selects the row {row} of the table there.'),
        why: t('The cell refers to a row of a table inside another record (for example, an approval step of a policy); the row has no own ID.'),
        click: t('Click.'),
        affects: t('Opens a widget; this table does not change. If the row is not found, the record opens on the table without a selection.'),
        hotkey: 'Alt + click on the cell',
    }),
    'grid.cellForm.cell.new': (v = {}, ctx = {}) => ({
        title: t('New'),
        what: t('Creates a new record of the linked segment from the title typed in the cell.'),
        why: t('The value is not in the reference list yet (red dashed underline).'),
        click: t('Type a new title into the cell, then click New.'),
        affects: t('A new record is created in the reference list and linked to the cell.'),
        stored: t('In the reference list'),
    }),
    'grid.cellForm.cell.copyLink': (v = {}, ctx = {}) => ({
        title: t('Copy link'),
        what: t('Copies a link to the record of this cell (not the value).'),
        why: t('Send the element to a colleague or open it later.'),
        click: t('Click, then paste the link into a chat or the address bar.'),
        affects: t('Nothing in the table.'),
    }),
    'grid.cellForm.cell.newTab': (v = {}, ctx = {}) => ({
        title: t('Open in a new tab'),
        what: t('Opens the record of this cell in a new browser tab.'),
        why: t('Keep this table as it is while you work with the element.'),
        click: t('Click.'),
        affects: t('Nothing in the table.'),
    }),
    'grid.cellForm.cell.records': (v = {}, ctx = {}) => ({
        title: t('Records'),
        what: t('Opens the list of records of the segment named in this cell.'),
        why: t('See the data behind a segment or source.'),
        click: t('Click.'),
        affects: t('Opens a list widget.'),
    }),
    'grid.cellForm.cell.openSource': (v = {}, ctx = {}) => ({
        title: t('Open source row'),
        what: t('Opens the row of the source this line of the summary came from.'),
        why: t('Edit a rule where it lives.'),
        click: t('Click.'),
        affects: t('Opens the source; the summary shows the change after it is saved.'),
    }),
    'grid.cellForm.cell.color': (v = {}, ctx = {}) => ({
        title: t('Text / fill colour'),
        what: t('Sets your own colour of the text (A) or of the background (palette) for the selected cells.'),
        why: t('Mark cells for yourself or for a printout.'),
        click: t('Click, pick a colour; white removes your colour.'),
        affects: t('Stored with the cell; a manual colour covers the colour of formatting rules; Ctrl+Z undoes.'),
        stored: t('In the record — after Save (element lists — at once)'),
        states: { 'fore': t('A — text colour.'), 'fill': t('Palette — background colour.') },
    }),
    'grid.cellForm.cell.clearCorrections': (v = {}, ctx = {}) => ({
        title: t('Clear manual corrections'),
        what: t('Removes the values typed in by hand in the selected cells; calculated values come back.'),
        why: t('Return the cell to the calculation.'),
        click: t('Click.'),
        affects: t('Dependent cells are recalculated; applied on Save; Ctrl+Z undoes.'),
        stored: t('In the record — after Save'),
        setting: 'attr.use_cells',
    }),
    // IE 2026 10 06 / ODOO-341407 (заказ Игоря п.1): кнопка есть только в колонке с флагом Multilingual (в форме записи — у переводимого поля) и открывает
    // переводы ЗНАЧЕНИЯ ячейки (поле записи строки), а не названия колонки
    'grid.cellForm.cell.translations': (v = {}, ctx = {}) => ({
        title: t('Translations'),
        what: t('Opens the values of this cell in English, Ukrainian and Russian.'),
        why: t('Fix or add a translation of the value.'),
        click: t('Click, edit the languages, apply.'),
        affects: t('Users of that language see the translated value.'),
        stored: t('In the record of the row'),
    }),
    'grid.cellForm.cell.copyRaw': (v = {}, ctx = {}) => ({
        title: t('Copy raw value'),
        what: t('Copies the value as it is stored: the full number, the id of a link, the date in ISO.'),
        why: t('For formulas, searches and support requests.'),
        click: t('Click.'),
        affects: t('Nothing in the table.'),
        hotkey: '⌥⌘C',
    }),
    'grid.cellForm.cell.comment': (v = {}, ctx = {}) => ({
        title: t('Comment'),
        what: t('Shows the comment field of this cell.'),
        why: t('Explain a manual value or leave a note for colleagues.'),
        click: t('Click, type the text.'),
        affects: t('The cell gets an orange corner; the comment is saved with the record.'),
        stored: t('In the record (_cells.comment) — after Save'),
    }),
    'grid.cellForm.cell.editValue': (v = {}, ctx = {}) => ({
        title: t('Edit value'),
        what: t('Opens a larger editor for the value of this cell (long text, JSON, code, date, duration).'),
        why: t('Easier than typing in a narrow cell.'),
        click: t('Click, edit, leave the form — the value is written into the cell.'),
        affects: t('The cell changes as with normal typing; Ctrl+Z undoes.'),
        stored: t('In the record — after Save'),
    }),
    // ---- форма ячейки — блоки FORMULA / CORRECTION / METRICS / DOCUMENTS / DETAILS / GANTT / CHART / LEGEND / RULES / FORMATS / STYLES / date-duration (14) ----
    'grid.cellForm.formula': (v = {}, ctx = {}) => ({
        title: t('Stock formula'),
        what: t('How the stock in this cell is built: stock of the previous period + inflows − outflows; uncovered amounts (⊘) are listed apart and not counted.'),
        why: t('Check the stock balance by eye; ✓ — the sum matches the cell; «other ±N» — part of the change comes from movements that are not in this formula.'),
        click: t('The cells in the formula are outlined in the table: = base, + inflow, − outflow, ⊘ uncovered.'),
        affects: t('Nothing — explanation only.'),
        stored: t('Collapsed state — in this browser'),
        setting: 'doc.params.influence_highlight · fe.ux.inflFormulaInDropdown',
        states: { 'stock': t('Stock cell: previous stock + inflows − outflows = result.'), 'flow': t('Inflow / outflow cell: which stock rows of the next periods it changes.'), 'unc': t('Uncovered cell: the movement is needed but impossible — the stock does not change.') },
    }),
    'grid.cellForm.correction': (v = {}, ctx = {}) => ({
        title: t('Correction'),
        what: t('Who changed this cell and how: your edits of this session, saved manual corrections (author, time), changes caused by other cells, failed pastes, difference to the compared model.'),
        why: t('Understand why the number differs from the calculation.'),
        click: t('Read top-down: was → now, the delta on the right.'),
        affects: t('Nothing — history only; Undo or Clear manual corrections revert.'),
        states: { 'user': t('✎ your edit in this session (not saved yet).'), 'saved': t('✓ a saved manual correction: author and time.'), 'linked': t('Share icon — changed through another cell (totals, decomposition).'), 'error': t('⚠ the pasted value could not be applied.'), 'cmp': t('⇄ differs from the compared process model.') },
    }),
    'grid.cellForm.metrics': (v = {}, ctx = {}) => ({
        title: t('Metrics of the cell'),
        what: t('The metrics (grade · metric · reason) that apply to this cell, with their facts.'),
        why: t('Why the cell is coloured and what problem it shows.'),
        click: t('Click a line — put the metric into the metrics chip of the table (or remove it); the chip then shows all cells with it.'),
        affects: t('The metrics chip filters the rows and dims other formatting; ◎ sets it for the whole workspace.'),
        stored: t('The chip — with the table'),
        setting: 'fe.ux.metricChip',
        states: { 'on': t('Ticked — the metric is in the metrics chip.'), 'off': t('Not ticked — click to add.') },
    }),
    'grid.cellForm.metrics.global': (v = {}, ctx = {}) => ({
        title: t('Workspace metrics chip'),
        what: t('Makes this metric the metrics chip of the whole workspace.'),
        why: t('See the same problem in every widget of the page.'),
        click: t('Click; Shift or Ctrl + click adds it to the current chip.'),
        affects: t('Widgets that accept the chip filter or re-read their data.'),
        stored: t('Workspace chips'),
        setting: 'fe.ux.metricChipGlobal',
        hotkey: 'Shift / Ctrl + click — add',
    }),
    // ---- IE 2026 10 01 / ODOO-5800 (пакет G): форма ячейки «проблема → причина → решение → деньги» — блоки story и Signals ----
    'grid.cellForm.storyProblem': (v = {}, ctx = {}) => ({
        title: t('Problem'),
        what: t('The main problem of this cell: kind (OOS, above max, expiry), period, quantity, days and the money at stake in USD.'),
        why: t('See at once what is wrong and how much it costs.'),
        // IE 2026 10 02 / ODOO-5800 (заказ Игоря: заголовок «Проблемы», раскрытие по клику вместо наведения): строка Click — под раскрытие по щелчку и заголовок PROBLEMS
        // (было: «Click the header — the details: period, quantity, amount and its basis (sale price or cost), other problems of the cell.»)
        click: t('Click a problem row or its arrow — the card with the solution opens under it; click a segment — its card; click again — the card closes. The cards are the only place of the details: problem — period, quantity, amount and its basis (sale price or cost), other problems, now / with solution; cause — all causes with facts and links; solution — all solutions with Simulate / Check with engine; money — formula, basis, risks. The header PROBLEMS folds the block into one line with the problem badges. A group row shows how many nodes have problems and the worst one; click — the list of nodes, click a node — its cards. Every problem of the cell is a row (the critical one first); the problem card has the tick box that puts the problem metric into the metrics chip of the table.'),   // IE 2026 10 03 / ODOO-5800 (CONTRACT-problems-v9.md, fe-56): список всех проблем, чекбокс в карточке   // IE 2026 10 03 / ODOO-5800 (CONTRACT v8 §1, fe-53): без «Details»; карточки — единственное место подробностей; групповая строка
        affects: t('Nothing — explanation only.'),
        stored: t('Not stored — calculated when the form opens'),
        setting: 'fe.ux.cellStory · fe.cellForm.storyProblem',
        states: { 'noprice': t('«no price» — the item has no sale price in USD; the amount is not shown instead of a guess.'), 'atleast': t('«≥ $X» — part of the quantity has no price; the amount is the lower bound.') },
    }),
    // ---- IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106012: «Прийнято» — подтверждение проблемы) ----
    'grid.cellForm.storyAccept': (v = {}, ctx = {}) => ({
        title: t('Accept the problem'),
        what: t('Marks the problem as known and agreed: it moves from PROBLEMS to the ACCEPTED block with your comment.'),
        why: t('Keep in PROBLEMS only what still needs work.'),
        click: t('Click Accept, write a comment (required) and, if needed, the month the acceptance holds to; Accept saves it, Cancel closes the dialog.'),
        affects: t('All users see the problem as accepted; cancel it in the ACCEPTED block.'),
        stored: t('On the server — signal marks'),
        setting: 'fe.ux.cellSignalAccept',
    }),
    'grid.cellForm.storyAccepted': (v = {}, ctx = {}) => ({
        title: t('Accepted problems'),
        what: t('Problems that users accepted: title, comment, who and when, valid to.'),
        why: t('See what was agreed and by whom.'),
        click: t('Click the header — fold or unfold the block; Cancel returns the problem to PROBLEMS.'),
        affects: t('Cancel removes the acceptance for all users.'),
        stored: t('On the server — signal marks'),
        setting: 'fe.ux.cellSignalAccept',
    }),
    'grid.cellForm.storyCauses': (v = {}, ctx = {}) => ({
        title: t('Causes'),
        what: t('One to three main causes of the problem with facts: dates, lead time, MOQ, limits, registrations.'),
        why: t('Understand why the problem happens, not only that it happens.'),
        click: t('Click a linked value to open the document, node or rule.'),
        affects: t('Nothing — explanation only.'),
        setting: 'fe.cellForm.storyCauses',
    }),
    'grid.cellForm.storySolutions': (v = {}, ctx = {}) => ({
        title: t('Solutions'),
        what: t('One to three levers (pull in an order, transfer from another node, change the lot, push, change the replenishment model) with the estimated effect in pieces, days and USD.'),
        why: t('Choose what to do and see what it gives before changing anything.'),
        click: t('Simulate — show the effect in the table as a preview (needs Simulation mode in the report settings); Check with engine — exact effect by the planning engine; Reset preview — remove the preview.'),
        affects: t('Nothing is saved: the preview is an estimate in the table, Save stays off.'),
        setting: 'fe.cellForm.storySolutions · fe.cellForm.storyPreview · doc.params.online_balance_preview',
        states: { 'estimate': t('estimate — a quick calculation from the node data.'), 'engine': t('engine — calculated by the planning engine in a separate session.') },
    }),
    'grid.cellForm.storyCompare': (v = {}, ctx = {}) => ({
        title: t('Now / with solution'),
        what: t('OOS, above max and expiry in pieces and USD, and the stock cover — now and with the chosen solution.'),
        why: t('Compare the result of a solution with the current plan.'),
        click: t('The «With solution» column appears after Simulate or Check with engine.') + ' ' + t('Under the table — which solution and how it was calculated (estimate / engine); engine notes: stock change before the edited month (document stages), virtual documents of the simulation.'),   // IE 2026 10 01 / ODOO-5800: заметки движка
        affects: t('Nothing — explanation only.'),
        setting: 'fe.cellForm.storyCompare',
    }),
    'grid.cellForm.storyRisks': (v = {}, ctx = {}) => ({
        title: t('Risks'),
        what: t('Write-off risks of the cell: batches that expire before they are sold, with quantity, date and amount at cost (or at sale price).'),
        why: t('See the money that may be lost on expiry.'),
        affects: t('Nothing — explanation only.'),
        setting: 'fe.cellForm.storyRisks',
    }),
    'grid.cellForm.storyPolicies': (v = {}, ctx = {}) => ({   // IE 2026 10 02 / ODOO-5800 (DESIGN §3.6, фаза 2 «Applied policies»): блок APPLIED POLICIES формы ячейки
        title: t('Applied policies'),
        what: t('The planning policies (algorithms) that formed the documents of this cell: mode, order of application, the rule record they came from, the documents touched and the effect.'),
        why: t('See which algorithm shaped the plan here and open the rule that enabled it.'),
        click: t('Click the Source link — open the policy rule (Planning policies segment); the header folds the block into one line with the policy names.'),
        affects: t('Nothing — explanation only.'),
        setting: 'fe.cellForm.storyPolicies',
    }),
    'grid.cellForm.documents': (v = {}, ctx = {}) => ({
        title: t('Documents'),
        what: t('The documents whose data make up this cell: kind, title, status.'),
        why: t('Trace a number to the orders and movements behind it.'),
        click: t('Click a title — open the document; collapsed — counts by kind and status.'),
        affects: t('Cells with the same documents are marked ⧉ in the table while this cell is selected.'),
        setting: 'fe.ux.sameDocHighlight · fe.ux.sameDocDetailed',
    }),
    'grid.cellForm.docsMore': (v = {}, ctx = {}) => ({   // IE 2026 10 29 / ODOO-5800 (ie-dm7 r62 #115629: D2): текст хвоста «N more documents», кнопки порции и «all»
        title: t('More documents'),
        what: t('Documents of this cell that the form has not loaded yet: their number and quantity.'),
        why: t('Open the whole list of documents behind the number without leaving the form.'),
        click: t('Click the text or «all» — load the whole rest (the next portion when the rest is too long); the portion button — load the next portion.'),
        affects: t('Nothing — explanation only.'),
        setting: 'not-cell_docs_more',
    }),
    'grid.cellForm.details': (v = {}, ctx = {}) => ({
        title: t('Details of the cell'),
        what: t('What happened in this cell: movements with documents, why they were planned so, stock and norms of the node.'),
        why: t('A full answer to «where does this number come from».'),
        click: t('Collapse / expand by the header; links open documents, nodes and rules.'),
        affects: t('Nothing — explanation only.'),
        stored: t('Collapsed state — in this browser'),
        setting: 'fe.ux.cellBadges · fe.cellForm.policyColumn',
    }),
    'grid.cellForm.gantt': (v = {}, ctx = {}) => ({
        title: t('Movements Gantt'),
        what: t('Documents of this node over a few months around the cell: orders, shipments, arrivals, allocations between them.'),
        why: t('See which receipt covers which shipment and what stays uncovered.'),
        click: t('Hover a bar — its document and linked intervals; click — open the document; the tags button — legend.'),
        affects: t('Nothing — explanation only.'),
        setting: 'fe.ux.ganttDocs · fe.cellForm.linkWindow',
    }),
    'grid.cellForm.chart': (v = {}, ctx = {}) => ({
        title: t('Stock chart of the node'),
        what: t('Stock, receipts, sales and DOS of this node for a few months around the cell; coloured zones are the stock norms.'),
        why: t('See the trend and whether the stock stays within the norms.'),
        click: t('Legend (tags) — switch series on and off; ↗ opens the chart widget of the page.'),
        affects: t('Nothing — explanation only.'),
        setting: 'fe.ux.cellChartAttr · fe.cellForm.excessZone · fe.ux.excessBandAlways',   // IE 2026 10 01 / ODOO-5800: + сверхнормативная зона панели DOS
    }),
    'grid.cellForm.legend': (v = {}, ctx = {}) => ({
        title: t('Legend'),
        what: t('What the colours and marks of the Gantt or the chart mean; ticks switch the series of the chart.'),
        why: t('Read the diagram correctly.'),
        click: t('Drag by the header to move; × closes.'),
        affects: t('Only what the diagram shows.'),
        setting: 'fe.ux.chartTipWithLegend (true — the chart tooltip stays on while the legend is open)',   // IE 2026 10 22 / ODOO-5800 (Igor 22.10): легенда открыта — тултипа нет
    }),
    'grid.cellForm.rules': (v = {}, ctx = {}) => ({
        title: t('Rules of the cell'),
        what: t('Supply rules that match this cell and their state here: active, not applicable (with the reason), linked, in force.'),
        why: t('See which rule made the movement and why another could not.'),
        click: t('Current — the movements of this cell go by this rule; hover a state badge for its meaning; ↗ opens the rule.'),
        affects: t('Nothing — explanation only; change a rule in its record.'),
        stored: t('Collapsed state — in this browser'),
        setting: 'fe.ux.cellRules · fe.ux.cellRulesCurrent',
        states: { 'active': t('Active — the rule works in this cell.'), 'not_applicable': t('Not applicable — the rule matches the row but cannot be used here (reason below).'), 'current': t('Current — the movements of this cell go by this rule.') },
    }),
    'grid.cellForm.rules.list': (v = {}, ctx = {}) => ({
        title: t('Open the rules list'),
        what: t('Opens the list of these rules, already filtered by the dimensions of the cell.'),
        why: t('Edit or compare the rules of this cell in their own list.'),
        click: t('Click the list icon (one per kind of rules).'),
        affects: t('Opens or reuses the list widget; the filter chip there is temporary.'),
        stored: t('Not stored (the chip lives in memory)'),
        setting: 'fe.ux.cellRulesOpenList',
    }),
    'grid.cellForm.formats': (v = {}, ctx = {}) => ({
        title: t('Formatting of the cell'),
        what: t('Conditional formatting rules that coloured this cell, with a sample of each.'),
        why: t('Know why the cell looks so.'),
        click: t('Tick a rule — the formatting chip above the table shows all cells of this rule.'),
        affects: t('The chip filters rows and dims other formatting; rules themselves do not change.'),
        stored: t('The chip — with the table'),
        setting: 'fe.ux.formatChip',
    }),
    'grid.cellForm.styles': (v = {}, ctx = {}) => ({
        title: t('Named styles'),
        what: t('Styles from the styles register (Stock · Critical, Grade · Bad, Band · Inflow…); ticked ones are in this cell.'),
        why: t('One style is changed in one place and applies in all reports that refer to it.'),
        click: t('Find a style, click to add or remove it; ↗ opens the style element.'),
        affects: t('The rule or row gets this style; saved with the record.'),
        stored: t('In the record — after Save'),
    }),
    'grid.cellForm.dateDuration': (v = {}, ctx = {}) => ({
        title: t('Date / duration'),
        what: t('Pick a date in the calendar or enter months, days, hours, minutes of a duration.'),
        why: t('No need to remember the input format.'),
        click: t('Click a day or change the numbers; the result is shown below.'),
        affects: t('The cell changes as with normal typing; Ctrl+Z undoes.'),
        stored: t('In the record — after Save'),
    }),
    // ---- метки ячеек — Marks (строка «Marks» в подсказке по Alt, cellMarks/cellMarks_html) (41) ----
    'grid.mark.format': (v = {}, ctx = {}) => ({
        title: t('Formatting'),
        what: t('The colour of this cell comes from a formatting rule (its name is shown).'),
        why: t('Rules colour cells by conditions: stock category, grade of a metric, alerts.'),
        click: t('The name tells the rule; F4 → FORMATS / METRICS shows all rules of the cell and lets you filter by them.'),
        affects: t('Only the look; the value is not changed.'),
        stored: t('Rules of the widget; styles — in the styles register'),
        setting: 'doc.conditional_format / attr.cf_rules · CSS-CLASS',
    }),
    'grid.mark.groupDup': (v = {}, ctx = {}) => ({
        title: t('Repeated total'),
        what: t('The total of this open group equals its only child row below, so it is muted to reduce noise.'),
        why: t('The same number twice in a row is visual noise.'),
        click: t('Read the value in the row below; hover the row to see this one normally.'),
        affects: t('Nothing: the value is the same, export and copy keep it.'),
        stored: t('Report option Repeated group totals; base default — Settings → Frontend → Grid defaults'),
        setting: 'doc.params.group_totals_repeat · fe.ux.gridGroupTotalsRepeat · fe.ux.gridGroupTotalsDimOpacity',
        states: { 'dim': t('A · Dim — the digits are barely visible.'), 'hover': t('B · Hover — the value appears when you hover the row.'), 'arrow': t('C · Arrow — «↓» instead of the value: see the row below.') },
    }),
    // IE 2026 11 02 / ODOO-350449 (заказ Игоря: p201 баланс — «Сигнали» типово, розкритий батьківський рядок без підсумків і сигналів (hover показує), підсумок рядка без сигналів — опція)
    'grid.mark.parentHide': (v = {}, ctx = {}) => ({
        title: t('Expanded group row'),
        what: t('This group row is open: its values and circles are muted, the rows below show the details.'),
        why: t('The totals of an open group repeat what its rows show below.'),
        click: t('Hover the row to see its values and circles; collapse the group to see its totals as usual.'),
        affects: t('Nothing: the values are the same, export and copy keep them.'),
        stored: t('Report option Expanded group rows; base default — Settings → Frontend → Grid defaults'),
        setting: 'doc.params.expanded_group_rows · fe.ux.parentRowHideExpanded · doc.params.group_totals_repeat',
    }),
    'grid.mark.infl': (v = {}, ctx = {}) => ({
        title: t('Influence on the stock'),
        what: t('This cell takes part in the stock of the selected cell: = the stock it starts from, + an inflow, − an outflow.'),
        why: t('See at once which numbers build the stock and which periods a movement changes.'),
        click: t('Blue = base, green + inflow, red − outflow; the formula with the sums — in the cell form (F4).'),
        affects: t('Nothing — highlight only; it follows the selection.'),
        stored: t('Report option (influence highlight)'),
        setting: 'doc.params.influence_highlight · Balance role (layout rows)',
        states: { 'base': t('= base: the stock of the previous period.'), 'plus': t('+ inflow: adds to the stock.'), 'minus': t('− outflow: is taken from the stock.') },
    }),
    'grid.mark.inflUnc': (v = {}, ctx = {}) => ({
        title: t('Uncovered — not in the stock'),
        what: t('A movement that is needed but cannot happen (nothing to ship, nothing to receive); it is not counted in the stock.'),
        why: t('Shows the shortage without distorting the stock balance.'),
        click: t('Hatched ⊘ green — a receipt that cannot happen; hatched ⊘ red — a write-off / shipment that cannot happen.'),
        affects: t('Excluded from the stock formula; listed there separately as «uncovered, not applied».'),
        stored: t('The report data (uncovered measures and alerts)'),
        setting: 'fe.ux.inflUncInherit',
        states: { 'plus': t('⊘ green — receipt impossible (not covered).'), 'minus': t('⊘ red — write-off needed but impossible (no stock).') },
    }),
    'grid.mark.alertChild': (v = {}, ctx = {}) => ({
        title: t('Part of an alert'),
        what: t('This row belongs to an alert row above (for example Uncovered or Expired) and is tinted with its colour.'),
        why: t('The alert is on a group row; the tint shows which detailed lines it covers.'),
        click: t('Stronger tint — the row names, lighter — the values; find the alert name in the parent row.'),
        affects: t('Only the look; in the stock formula uncovered lines are excluded (⊘).'),
        stored: t('Derived from the alert rows of the report'),
        setting: 'fe.ux.gridAlertChildMark',
    }),
    'grid.mark.tabRow': (v = {}, ctx = {}) => ({
        title: t('Section band'),
        what: t('A stripe that opens a section of the report (PO, +, −, Sales, =); the lines below it until the next band belong to it.'),
        why: t('Long reports are read by sections: orders, inflow, outflow, sales, balance.'),
        click: t('The colour of the band is its section; it has no values of its own.'),
        affects: t('Not a data row: it is not hidden as empty and follows the search — shown while its section has visible rows.'),
        stored: t('Layout of the report (row style)'),
        setting: 'Style of the layout row · CSS-CLASS Band · … · fe.ux.gridBandRowsFollow',
        states: { 'tab': t('Band of the layout (Tab row).'), 'band': t('Named band style (Band · Orders / Inflow / Outflow / Sales / Balance).') },
    }),
    'grid.mark.memoRow': (v = {}, ctx = {}) => ({
        title: t('Of which…'),
        what: t('A part of the row above shown for information (for example «of which uncovered» or «of which expired»).'),
        why: t('Shows how much of the amount is problematic without a separate report.'),
        click: t('Read together with the row above; it is already inside that amount.'),
        affects: t('Not added to totals and to the stock formula — no double counting.'),
        stored: t('The report layout'),
        setting: 'fe.ux.memoRows',
    }),
    'grid.mark.dateBar': (v = {}, ctx = {}) => ({
        title: t('Date line'),
        what: t('A thin line at the bottom of date cells: the validity period of the row on a common time axis of the column.'),
        why: t('Compare periods of many rows at a glance: which are over, which run now, which are endless.'),
        click: t('The border between the From and To cells is today: the line left of it is past, right — future; a fading end — no end date; a tick — where a single date lies between the earliest and the latest.'),
        affects: t('Only the look; the dates are not changed.'),
        stored: t('Column option date-bar (off / tick / bar / interval)'),
        setting: 'column option date-bar · fe.ux.gridDateBars · fe.data.gridDateBarsSeam',
        states: { 'pair': t('From / To pair: the period of the row; the border of the two cells is today.'), 'open': t('Fading end — no end date (valid without limit).'), 'tick': t('Tick — the position of this date between the earliest and the latest in the column.'), 'bar': t('Bar — from the earliest date of the column to this one.') },
    }),
    'grid.mark.selFrame': (v = {}, ctx = {}) => ({
        title: t('Selection frame'),
        what: t('The frame around the selected cells; its style is chosen for readability on coloured cells.'),
        why: t('A plain orange frame gets lost on red or orange fills.'),
        click: t('Only shows where the selection is; the faint orange line across the table marks the bottom row of the selection.'),
        affects: t('Nothing.'),
        stored: t('Report / list option Selection frame; base default — Settings → Frontend → Grid defaults'),
        setting: 'doc.params.selection_frame · fe.ux.gridSelectionFrame',
        states: { 'classic': t('Classic — thin semi-transparent orange.'), 'halo': t('A · Halo — orange with a white edging.'), 'dark': t('B · Dark — orange with a dark edging.'), 'double': t('C · Double — two thin orange lines.') },
    }),
    'grid.mark.sameValue': (v = {}, ctx = {}) => ({
        title: t('Same text'),
        what: t('This cell has exactly the same text as the selected cell (here or in another widget of the page).'),
        why: t('Find the same country, subject or code across tables.'),
        click: t('Select a cell — every other cell with the same text gets its text highlighted.'),
        affects: t('Nothing — highlight only.'),
        setting: 'fe.ux.gridSameValueHighlight · fe.data.gridSameValueMinLen · fe.ux.gridSameValueCrossWidget',
    }),
    'grid.mark.sameDoc': (v = {}, ctx = {}) => ({
        title: t('Same documents'),
        what: t('The data of this cell come from the same documents as the selected cell (the same order counted by another date, for example).'),
        why: t('One document appears in several lines grouped by different dates.'),
        click: t('⧉ and a purple frame — same documents; the selected cell has the frame only. The list of documents — F4 → DOCUMENTS.'),
        affects: t('Nothing — highlight only.'),
        setting: 'fe.ux.sameDocHighlight · fe.ux.sameDocDetailed',
        states: { 'same': t('⧉ — same documents as the selected cell.'), 'anchor': t('The selected cell whose documents are traced.') },
    }),
    'grid.mark.metricHit': (v = {}, ctx = {}) => ({
        title: t('Matched by the chip'),
        what: t('A frame around the cells that the metrics or formatting chip selects.'),
        why: t('See where the chosen problem is in the table.'),
        click: t('Hover the chip — all matching cells are framed; ‹ › on the chip step through them (the current one is darker).'),
        affects: t('Nothing — highlight only.'),
        setting: 'fe.ux.metricHitBorder',
        states: { 'hit': t('Light frame — matches the chip.'), 'current': t('Dark frame — the current stop of ‹ ›.') },
    }),
    'grid.mark.metricFill': (v = {}, ctx = {}) => ({
        title: t('Metric in the cell'),
        what: t('The cell is coloured by the metric that applies to its data (the worst grade wins); the name of the metric is shown.'),
        why: t('The colour tells why the planned movement is a problem (for example not covered, expired, outside the horizon).'),
        click: t('Read the grade · metric · reason; F4 → METRICS gives the facts and lets you filter by the metric.'),
        affects: t('Only the look; the metrics chip can filter by it.'),
        stored: t('Report option Metric data in cells'),
        setting: 'doc.params.metric_data · fe.ux.metricFill · fe.ux.metricFillGroups',
    }),
    'grid.mark.filterDim': (v = {}, ctx = {}) => ({
        title: t('Muted by the filter'),
        what: t('This coloured cell does not match the metrics, formatting or styles chip, so it is muted.'),
        why: t('The cells you filtered for stand out.'),
        click: t('Bright cells — match the chip; muted — coloured by other rules. Remove the chip or enable «Show other formatting» to see all.'),
        affects: t('Only the look.'),
        stored: t('Chips of the table'),
        setting: 'fe.ux.gridStyleFilterDim',
        states: { 'metrics': t('by the metrics chip'), 'formatting': t('by the formatting chip'), 'styles': t('by the styles filter') },
    }),
    'grid.mark.mergeBack': (v = {}, ctx = {}) => ({
        title: t('Value moved to the row start'),
        what: t('The value of this row belongs to another column (see the highlighted header); it is shown from the start of the row because the columns before it are empty.'),
        why: t('Group rows read like titles instead of a value floating in the middle.'),
        click: t('The column of the value is highlighted in the header when you select the cell; editing goes to that column.'),
        affects: t('Only the look; export puts the value into its own column.'),
        setting: 'fe.ux.gridMergeBack · fe.ux.mergeBackChip',
    }),
    'grid.mark.breakGap': (v = {}, ctx = {}) => ({
        title: t('Column break'),
        what: t('A gap before this group of columns; the arrow in it tells the direction between the blocks (for example From → To).'),
        why: t('Read the direction on every row without looking at the header.'),
        click: t('→ to, ← from, ↔ both ways, ⇒ where it can be sold; a dashed gap — just a separator.'),
        affects: t('Only the look.'),
        stored: t('Column setting Break before'),
        setting: 'Break before (column / layout row) · fe.ux.gridBreakCarry',
        states: { 'gap': t('Gap — a separator between blocks.'), 'arrow': t('→ — towards this block.'), 'arrow_left': t('← — from this block.'), 'arrow_both': t('↔ — both ways.'), 'arrow_double': t('⇒ — where it can be sold (possible sales country).'), 'plan': t('Plan start — the hatched gap with the flag marks where the plan period begins (the period that contains the Stock date): to the right is plan, to the left is fact. Switch: fe.ux.planStartMark.') },
    }),
    'grid.mark.direction': (v = {}, ctx = {}) => ({
        title: t('Direction'),
        what: t('The arrow before the value tells the role of this place: ← stock comes from it (inflow), → goes to it (outflow, stock), ⇒ possible sales country.'),
        why: t('Countries and subjects appear in both roles; the arrow removes the doubt.'),
        click: t('← from, → to, ⇒ can be sold to, ↔ both ways.'),
        affects: t('Only the look.'),
        stored: t('Field option Direction of the report layout'),
        setting: 'Direction (layout row field) · fe.ux.cardBreak',
        states: { 'from': t('← from (inflow comes from here).'), 'to': t('→ to (outflow / stock goes here).'), 'to_double': t('⇒ possible sales country.'), 'both': t('↔ both ways.') },
    }),
    'grid.mark.edit': (v = {}, ctx = {}) => ({
        title: t('Edited, not saved'),
        what: t('This cell was changed in this session; the corner badge shows the change (hover to read it).'),
        why: t('Keeps track of what you (or your edits through totals) changed before saving.'),
        click: t('Blue corner — your edit; green / red corner — changed through your edit in another cell (up / down); pink cell — a pasted value was not applied. Hover the corner — the delta; F4 → CORRECTION — was → now.'),
        affects: t('The change goes to the base only on Save; Ctrl+Z reverts it.'),
        stored: t('Session (until Save)'),
        hotkey: 'Ctrl+Z',
        states: { 'user': t('Blue corner — your edit.'), 'indirect': t('Green / red corner — changed through your edit in another cell (totals, decomposition), up / down.'), 'error': t('Pink cell — the pasted value could not be applied.') },
    }),
    'grid.mark.manualCorrection': (v = {}, ctx = {}) => ({
        title: t('Manual correction'),
        what: t('The value of this cell was entered by hand and saved; it overrides the calculation.'),
        why: t('Planners fix numbers the model cannot know.'),
        click: t('Blue corner — a saved manual value; F4 → CORRECTION shows who, when and the value before.'),
        affects: t('The calculation keeps this value until the correction is cleared (eraser).'),
        stored: t('In the record (_cells)'),
        setting: 'attr.use_cells',
    }),
    'grid.mark.note': (v = {}, ctx = {}) => ({
        title: t('Comment'),
        what: t('Someone left a comment on this cell.'),
        why: t('Explanations of manual values and notes for colleagues.'),
        click: t('Open the cell form (F4) to read or edit the comment.'),
        affects: t('Nothing in the calculation.'),
        stored: t('In the record (_cells.comment)'),
    }),
    'grid.mark.flash': (v = {}, ctx = {}) => ({
        title: t('Changed just now'),
        what: t('A short flash marks the cells changed by your last action.'),
        why: t('See every cell your edit touched, including totals.'),
        click: t('Yellow — changed now; red — your input was replaced by the calculation or cannot be edited.'),
        affects: t('Nothing.'),
        states: { 'change': t('Yellow — changed by the last action.'), 'override': t('Red — replaced by the calculation / not editable.') },
    }),
    'grid.mark.compare': (v = {}, ctx = {}) => ({
        title: t('Differs from the compared model'),
        what: t('In the model you compare with, this cell has another value; the badge shows the difference.'),
        why: t('See what a scenario or a branch changes.'),
        click: t('Hover the corner — +N / −N (or ≠ for texts); the exact value of the other model is in the tooltip.'),
        affects: t('Nothing — comparison only.'),
        stored: t('Compare mode of the widget'),
    }),
    'grid.mark.branchCopy': (v = {}, ctx = {}) => ({
        title: t('Changed in the branch copy'),
        what: t('This field of the branch copy differs from the working version.'),
        why: t('Review what the branch changes before merging.'),
        click: t('Hover the corner — the difference; the tooltip gives the working value.'),
        affects: t('Nothing.'),
        stored: t('Branch copy of the record'),
    }),
    // IE 2026 10 27 / ODOO-5800 (заказ Игоря 27.10: подсветка изменений записи из аудита)
    'grid.mark.auditDiff': (v = {}, ctx = {}) => ({
        title: t('Changed between versions'),
        what: t('This field or cell differs between this version of the record and the version it is compared with.'),
        why: t('See what an event in the change log changed.'),
        click: t('Hover the corner — +N / −N, ±days or ≠; the value of the other version is in the tooltip.'),
        affects: t('Nothing.'),
        stored: t('Change log of the record'),
    }),
    'grid.mark.empty': (v = {}, ctx = {}) => ({
        title: t('Empty row'),
        what: t('This row has no values in the data columns (or is switched off by Use); it stays visible because rows inside it have data.'),
        why: t('Grey rows are a frame for the lines below, not data.'),
        click: t('Look at the rows below it; with «Hide empty rows, columns, tabs» off the tint disappears.'),
        affects: t('Only the look; such rows count as empty for the filter.'),
        stored: t('Widget filter Hide empty rows, columns, tabs'),
        setting: 'non-empty-widget · viewParams.<grid>.hideEmptyRows',
    }),
    'grid.mark.zero': (v = {}, ctx = {}) => ({
        title: t('Zero'),
        what: t('The value of this cell is 0 — it is hidden to keep the table readable (a dash means a value so small it rounds to zero).'),
        why: t('Zeros everywhere hide the meaningful numbers.'),
        click: t('An empty-looking cell with a value 0; F4 or editing shows the 0.'),
        affects: t('Nothing — the value is 0 in totals and export.'),
        setting: 'fe.ux.highlightSkipHidden',
        states: { 'hidden': t('0 hidden.'), 'dash': t('«-» — rounds to zero.') },
    }),
    'grid.mark.statusChip': (v = {}, ctx = {}) => ({
        title: t('Status'),
        what: t('The status or grade of the row as a coloured pill; the colour is set in the reference list, the same everywhere.'),
        why: t('Statuses are read at a glance in any table.'),
        click: t('Green — done / good, yellow — attention, orange — soft error, red — critical, grey — neutral.'),
        affects: t('Nothing.'),
        stored: t('Reference lists STATUS* / GRADE'),
        setting: 'fe.ux.gradeChip',
    }),
    'grid.mark.currentBadge': (v = {}, ctx = {}) => ({
        title: t('Current'),
        what: t('This setting (or its variant) is the one open in the widget now.'),
        why: t('Find your place in a long list of settings.'),
        click: t('Current — this setting; Current · variant — a variant of it is open.'),
        affects: t('Nothing.'),
    }),
    'grid.mark.filterTotal': (v = {}, ctx = {}) => ({
        title: t('Total of the filtered rows'),
        what: t('Italic dotted — the group total counts only the rows the filter shows; muted — the total of all rows (it cannot be recounted).'),
        why: t('Totals match what you see under a search or a chip.'),
        click: t('The tooltip gives the total of all rows in brackets.'),
        affects: t('Display only; the data, saving and export keep the full totals; such cells cannot be edited.'),
        setting: 'fe.ux.filterTotalsRecalc · fe.ux.filterTotalsAllPaths',
        states: { 'total': t('Recounted for the filter.'), 'stale': t('Total of all rows (not recounted).') },
    }),
    'grid.mark.heat': (v = {}, ctx = {}) => ({
        title: t('Heat colour'),
        what: t('The background shows the size of the value compared with the other cells of the same column group and tree level.'),
        why: t('Big and small numbers stand out without reading them.'),
        click: t('Negative — from orange (small) to red (large); positive — from pale blue (small) to pale yellow (large).'),
        affects: t('Only the look.'),
        stored: t('Column option HSL group'),
        setting: 'column option HSL group',
    }),
    'grid.mark.negative': (v = {}, ctx = {}) => ({
        title: t('Negative'),
        what: t('The value is below zero and shown in red.'),
        why: t('A negative stock or balance is a problem to notice.'),
        click: t('Red number — less than zero.'),
        affects: t('Nothing.'),
    }),
    'grid.mark.dataBar': (v = {}, ctx = {}) => ({
        title: t('Data bar'),
        what: t('A bar inside the cell shows the value relative to the other cells of the row.'),
        why: t('Compare periods without reading the numbers.'),
        click: t('Longer bar / taller column — larger value; negative values in another colour.'),
        affects: t('Only the look.'),
        stored: t('Field or layout row option Row style'),
        setting: 'row_style (field) · rs (layout row)',
        states: { 'bars': t('Data bars — horizontal fill.'), 'columns': t('Data columns — a small column.') },
    }),
    'grid.mark.autoValue': (v = {}, ctx = {}) => ({
        title: t('Automatic value'),
        what: t('The value of this filter row is taken at run time from the workspace selector (or recomputed from Source).'),
        why: t('You do not need to enter it — it follows the chips of the workspace.'),
        click: t('Tinted italic row; the Value cell cannot be edited.'),
        affects: t('The filter uses the current selector values each time the report runs.'),
        stored: t('Filter settings of the widget'),
    }),
    'grid.mark.customValue': (v = {}, ctx = {}) => ({
        title: t('Not in the list'),
        what: t('The text in this cell does not match any element of the reference list.'),
        why: t('A typo or a new element that does not exist yet.'),
        click: t('Correct the value from the list, or create the element: F4 → New.'),
        affects: t('A link to an unknown element does not work in calculations until it is fixed.'),
        setting: 'column option customValueWarning',
    }),
    'grid.mark.exprValue': (v = {}, ctx = {}) => ({
        title: t('Expression / text'),
        what: t('The cell holds an expression (starts with =) calculated when the widget runs, or a plain text (starts with #) instead of a link to a record.'),
        why: t('Parameters can follow other values (for example = workspace.params.version) or be fixed text.'),
        click: t('Boxed names inside an expression are fields it reads; edit the cell to see the full formula.'),
        affects: t('The value is computed at run time; the reference list is not checked for it.'),
        stored: t('In the record (settings)'),
        states: { 'expression': t('= expression, calculated at run time.'), 'literal': t('# plain text.') },
    }),
    'grid.mark.useOff': (v = {}, ctx = {}) => ({
        title: t('Switched off'),
        what: t('The row is switched off by Use: it stays in the settings but is not applied.'),
        why: t('Keep a line for later without deleting it.'),
        click: t('Tick Use in the row header to switch it on again.'),
        affects: t('Not applied; the row and its children count as empty and hide with «Hide empty rows, columns, tabs».'),
        stored: t('In the record'),
    }),
    'grid.mark.rowState': (v = {}, ctx = {}) => ({
        title: t('New / changed row'),
        what: t('The row header is green for a new row and yellow for a changed one; not saved yet.'),
        why: t('See which lines your Save will write.'),
        click: t('Green — added, yellow — changed.'),
        affects: t('The colour goes away after Save; Ctrl+Z reverts changes of this session.'),
        stored: t('Session (until Save)'),
        states: { 'new': t('Green — a new row.'), 'modified': t('Yellow — a changed row.') },
    }),
    'grid.mark.cascadeDirty': (v = {}, ctx = {}) => ({
        title: t('Needs recalculation'),
        what: t('The calculation node of this row changed and has not been recalculated yet; the values may be outdated.'),
        why: t('Do not trust the numbers of this row until the cascade runs.'),
        click: t('Yellow row — outdated; run the calculation (cascade) to refresh it.'),
        affects: t('Values may change after the recalculation.'),
        stored: t('The calculation cascade (server)'),
    }),
    'grid.mark.compareRow': (v = {}, ctx = {}) => ({
        title: t('Comparison row'),
        what: t('A grey row under a line compares it with another version: ≡ prev — its value there, Δ — the difference, Δ% — the difference in percent.'),
        why: t('See the change without a second report.'),
        click: t('Read with the main row above.'),
        affects: t('Not data of their own: they follow the main row.'),
        stored: t('Compare mode of the report'),
        states: { 'prev': t('≡ prev — value in the compared version.'), 'delta': t('Δ — difference.'), 'deltaPct': t('Δ% — difference in percent.') },
    }),
    'grid.mark.stickyGroup': (v = {}, ctx = {}) => ({
        title: t('Current group'),
        what: t('The title of the group you are scrolling through stays at the top of the table.'),
        why: t('Know which group the rows belong to in a long list.'),
        click: t('Field name in normal font, its value in bold.'),
        affects: t('Nothing.'),
        setting: 'fe.ux.gridStickyGroupOnlyScrolled',   // IE 2026 11 02 / ODOO-349799 (sticky-group): полоса — только когда строка группы ушла за верхний край
    }),
    'grid.mark.placeholder': (v = {}, ctx = {}) => ({
        title: t('Default value'),
        what: t('The field is empty; the grey text is the value the system uses by default.'),
        why: t('You only need to fill the field to change the default.'),
        click: t('Grey italic — not saved, just shown; type a value to override it.'),
        affects: t('The default applies while the field stays empty.'),
    }),
    'grid.mark.dimHighlight': (v = {}, ctx = {}) => ({
        title: t('Selected in the graph'),
        what: t('The row matches the nodes you selected in the flow graph of the page.'),
        why: t('Find in the table what you picked on the graph.'),
        click: t('Orange outline — matching row; clear the selection in the graph to remove it.'),
        affects: t('Nothing.'),
    }),

    // === U5 additions end ===
}

export default grid
